module.exports = __webpack_public_path__ + "static/img/Nine of Cups.eafd31b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/tarot_image/Nine of Cups.jpg
// module id = 1283
// module chunks = 0